import styled from "styled-components";

export const ChangeNISStatusWrapper = styled.div`
  display: flex;
  flex-direction: column;
  .status-field {
    margin-top: 24px;
    margin-bottom: 24px;
  }

  .form-field {
    padding: 24px 16px 16px 0px;
  }

  .form-container {
    padding-left: 16px;
  }
`;
